import { render, staticRenderFns } from "./PackageTracking.vue?vue&type=template&id=0cefed70&scoped=true"
import script from "./PackageTracking.vue?vue&type=script&lang=js"
export * from "./PackageTracking.vue?vue&type=script&lang=js"
import style0 from "./PackageTracking.vue?vue&type=style&index=0&id=0cefed70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cefed70",
  null
  
)

export default component.exports